<template>
  <div>
    <NavBar />
    <StudentAttendanceList @save="handleSave"/>
    <MakeupClassTable :refresh-key="refreshKey" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import NavBar from "../components/NavBar.vue";
import StudentAttendanceList from "../components/StudentAttendanceList.vue";
import MakeupClassTable from "../components/MakeupClassTable.vue";

const refreshKey = ref(0);
const handleSave = () => {
  refreshKey.value++;
};
</script>